import { useTheme } from '@emotion/react';
import { Button, Dialog, DialogActions, Stack, Typography } from '@mui/material';
import React from 'react';
import FormTextField from '../components/FormTextField';
import { buttonStyle2, dialogButtonCancel } from '../utils/commonStyle';
import { Form, Formik } from 'formik';
import { useRef } from 'react';
import * as yup from 'yup';
import { setLoading } from '../redux/features/appSlice';
import appapi from '../api/apiClient';
import { showmessage } from '../utils/toastr';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { initShipCharterers, initShipManagers, initShipOperators, initShipOwners } from '../redux/features/layoutSlice';

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '528px',
    margin: '8px',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100% - 20px)',
  },
};

export default function ConfirmArchiveDialog({ modelOpen, onModelHandleClose, data, type, status }) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const text = theme.palette.primary.text;

  const handleArchive = async (values) => {
    dispatch(setLoading(true));
    const response = await appapi.delete(type === 'user' ? `user-management/${data?._id}` : type === 'contact' ? `contact-management/companyContact/${data?._id}` : `fleet/ship/${data?._id}`);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        dispatch(initShipOwners())
        dispatch(initShipManagers());
        dispatch(initShipOperators());
        dispatch(initShipCharterers());
        showmessage(data?.message);
        onModelHandleClose(true);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  const handleUnArchive = async (values) => {
    dispatch(setLoading(true));
    const response = await appapi.put(type === 'user' ? `user-management/restore/${data?._id}` : type === 'contact' ? `contact-management/companyContact/restore/${data?._id}` : `fleet/restore/${data?._id}`);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        dispatch(initShipOwners())
        dispatch(initShipManagers());
        dispatch(initShipOperators());
        dispatch(initShipCharterers());
        showmessage(data?.message);
        onModelHandleClose(true);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
    >
      <Stack className="p-[24px]">
        <Typography
          className="fs-16 ff-Roboto fw-medium"
          color={text}
        >
          {status === 1 ? t(`Confirm Archive`) : t(`Confirm Restore`)}
        </Typography>
        <Typography
          className="fs-14 ff-Roboto fw-regular !mt-[10px]"
          color={text}
        >
          {status === 1 ? t(`Are you sure you want to archive?`) : t(`Are you sure you want to restore?`)}
        </Typography>
        <Formik
          innerRef={formRef}
          enableReinitialize={false}
          initialValues={{
            userId: [],
          }}
          onSubmit={(values) => {
            if (status === 1) {
              handleArchive(values);
            } else if (status === 0) {
              handleUnArchive(values);
            }
          }}
        >
          {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue }) => (
            <Form autoComplete="off">
              <DialogActions
                className="!justify-end"
                style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
              >
                <Button
                  sx={[
                    dialogButtonCancel,
                    {
                      color: theme.palette.primary.main,
                      '&:hover': {},
                    },
                  ]}
                  style={{ width: '112px', height: '48px' }}
                  onClick={() => {
                    onModelHandleClose(false);
                  }}
                >
                  {t('Close')}
                </Button>
                <Button
                  sx={[
                    buttonStyle2,
                    {
                      color: theme.palette.background.main,
                      textTransform: 'uppercase',
                      backgroundColor: type === 'accept' ? '#00A632' : '#CF1010',
                      '&:hover': {
                        backgroundColor: type === 'accept' ? '#00A632' : '#CF1010',
                      },
                    },
                  ]}
                  style={{ width: '112px', height: '48px' }}
                  //   disabled={!(dirty && isValid)}
                  type="submit"
                  variant="contained"
                >
                  {status === 1 ? t('Archive') : t('Restore')}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Stack>
    </Dialog>
  );
}
